var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-content g9" },
        [
          _c(
            "h2",
            { staticClass: "breadcrumb" },
            [
              _c("router-link", { attrs: { to: _vm.project.url } }, [
                _vm._v(_vm._s(_vm.project.title)),
              ]),
              _vm._v(" " + _vm._s(_vm.program.title)),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Accord",
            {
              attrs: {
                title: (_vm.isActives ? "Active" : "Archived") + " studies",
              },
            },
            [
              _c(
                "div",
                { staticClass: "grid-33w" },
                [
                  _vm._l(
                    _vm.program.studies.filter(function (x) {
                      return x.isArchived == !_vm.isActives
                    }),
                    function (study) {
                      return _c("ProjectTile", {
                        key: study.studyId,
                        attrs: { info: study },
                      })
                    }
                  ),
                  _vm._v(" "),
                  _vm.isActives && !_vm.program.isArchived
                    ? _c(
                        "div",
                        {
                          staticClass: "tile tile-project tile-project-create",
                        },
                        [
                          _c("p", { on: { click: _vm.onNewStudyClick } }, [
                            _vm._v(
                              "\n                            Create study\n                        "
                            ),
                          ]),
                        ]
                      )
                    : _vm._e(),
                ],
                2
              ),
            ]
          ),
          _vm._v(" "),
          _vm.isActives && !_vm.program.isArchived
            ? _c(
                "form",
                {
                  attrs: { action: "#", method: "post", id: "form" },
                  on: { submit: _vm.onSaveSettingsSubmit },
                },
                [
                  _c("FormBuilder", {
                    attrs: {
                      formData: _vm.settingsFormData,
                      formValue: _vm.program,
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "button",
                    { staticClass: "right", class: { loading: _vm.isLoading } },
                    [_vm._v("Save")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _c("Modal", { ref: "modalNewStudy", attrs: { title: "Create study" } }, [
        _c(
          "form",
          { on: { submit: _vm.onNewStudySubmit } },
          [
            _c("div", { staticClass: "input", attrs: { type: "text" } }, [
              _c("label", [
                _c("span", [_vm._v("Name")]),
                _vm._v(" "),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.newStudyName,
                      expression: "newStudyName",
                    },
                  ],
                  ref: "studyNameInput",
                  attrs: { type: "text", placeholder: "New study name" },
                  domProps: { value: _vm.newStudyName },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.newStudyName = $event.target.value
                    },
                  },
                }),
              ]),
            ]),
            _vm._v(" "),
            _vm.templates.length > 0 || _vm.statictemplates.length > 0
              ? [
                  _c(
                    "div",
                    { staticClass: "input", attrs: { type: "select" } },
                    [
                      _c("label", [
                        _c("span", [_vm._v("Based on template")]),
                        _vm._v(" "),
                        _c(
                          "select",
                          {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.newStudyTemplate,
                                expression: "newStudyTemplate",
                              },
                            ],
                            on: {
                              change: function ($event) {
                                var $$selectedVal = Array.prototype.filter
                                  .call($event.target.options, function (o) {
                                    return o.selected
                                  })
                                  .map(function (o) {
                                    var val = "_value" in o ? o._value : o.value
                                    return val
                                  })
                                _vm.newStudyTemplate = $event.target.multiple
                                  ? $$selectedVal
                                  : $$selectedVal[0]
                              },
                            },
                          },
                          [
                            _vm.statictemplates.length > 0
                              ? _vm._l(
                                  _vm.statictemplates,
                                  function (template) {
                                    return _c(
                                      "option",
                                      {
                                        domProps: { value: template.fileName },
                                      },
                                      [
                                        _vm._v(
                                          "\n                                        " +
                                            _vm._s(template.name) +
                                            "\n                                    "
                                        ),
                                      ]
                                    )
                                  }
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.templates.length > 0
                              ? _vm._l(_vm.templates, function (template) {
                                  return _c(
                                    "option",
                                    {
                                      domProps: { value: template.templateId },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                        " +
                                          _vm._s(template.title) +
                                          "\n                                    "
                                      ),
                                    ]
                                  )
                                })
                              : _vm._e(),
                          ],
                          2
                        ),
                      ]),
                    ]
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "right edit", class: { loading: _vm.isLoading } },
              [_vm._v("Create study")]
            ),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }